import { render, staticRenderFns } from "./AppKeyValueItem.vue?vue&type=template&id=19f90b2a&scoped=true&"
import script from "./AppKeyValueItem.vue?vue&type=script&lang=js&"
export * from "./AppKeyValueItem.vue?vue&type=script&lang=js&"
import style0 from "./AppKeyValueItem.vue?vue&type=style&index=0&id=19f90b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f90b2a",
  null
  
)

export default component.exports